<template>
  <div class="content-main">
    <HeaderBar :text="social.header" :backgroundUrl="social.headerUrl"></HeaderBar>
    <div class="content">
      <div class="container">
        <template v-if="social.facebook.length !== 0">
          <div class="head">
            <h2><i class="fa fa-facebook-official" aria-hidden="true"></i> <i>Facebook</i></h2>
          </div>
          <div class="detail">
            <a href="https://www.facebook.com/DSS.KMUTT" target="_blank">SCiUS Program, Office of Engineering Science Classroom, KMUTT</a><br>
            <a href="https://www.facebook.com/ESCKMUTTStudentCommitee" target="_blank">คณะกรรมการนักเรียน ห้องเรียนวิศว์-วิทย์</a>
          </div>
        </template>

        <template v-if="social.youtube.length !== 0">
          <div class="head">
            <h2><i class="fa fa-youtube-play" aria-hidden="true"></i> <i>Youtube</i></h2>
          </div>
          <div class="detail">
            <a href="https://youtu.be/SZ_dadJ_LnY" target="_blank">ESC KMUTT - แนะนำห้องเรียนวิศว์-วิทย์</a><br>
            <a href="https://youtu.be/uaM8vlEiQ7c" target="_blank">TR10 : ทำความรู้จักดรุณสิกขาลัย โครงการวมว. และการสอบเข้าต้องทำยังไงบ้าง</a>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderBar from '../COMMON/HeaderBar'

export default {
  components: {
    HeaderBar
  },
  props: ['social']
}
</script>

<style scoped>

  .content-main {
    padding-bottom: 60px 0;
  }

  .content {
    padding: 60px 0;
  }

  .head, .detail {
    margin-bottom: 30px;
  }

  a:hover {
    text-decoration: underline;
  }

  .fa-facebook-official {
    color: #3b5998;
  }

  .fa-youtube-play {
    color: #FF0000;
  }

</style>



// WEBPACK FOOTER //
// src/components/STUDENTS/Social.vue